import { Formik } from 'formik'
import { Typography } from '@mui/material'
import { connect, useSelector } from 'react-redux'

import { i18nRegOrder } from '../i18n'
import { GlobalState } from '../../../data/store'
import { messages } from '../../../utils/i18n/messages'
import { useTranslateSingle } from '../../../hooks/translate'
import { registerOrder } from '../../../data/actions/ordersActions'
import { RegisterOrderFormMobile } from './RegisterOrderFormMobile'
import { showNotification } from '../../../data/actions/notificationActions'
import { getRegisterOrderFormInitialValues, handleSubmitForm, handleValidateForm } from '../formUtils'

import './styles.css'

export function RegisterOrderMobileComponent(props: any) {
    const user = useSelector((state: GlobalState) => state.users.loggedIn)

    const { _id, role } = user

    const { offices } = useSelector((state: GlobalState) => state.econt)

    const title = useTranslateSingle(i18nRegOrder.title)
    const completeCaptcha = useTranslateSingle(messages.completeCaptcha)

    const initialValues = getRegisterOrderFormInitialValues(user, offices)

    return (
        <div className="register-order-container-mobile">
            <Typography variant="h5" className="register-order-header">
                {title}
            </Typography>
            <Formik
                initialValues={initialValues}
                validate={(values) => handleValidateForm(values)}
                onSubmit={async (values: any, { setSubmitting, resetForm }) => {
                    if (!values.captchaToken) {
                        props.showNotification(completeCaptcha, 'error')
                        return
                    }

                    handleSubmitForm(values, setSubmitting, resetForm, props.registerOrder, _id, role)
                }}
            >
                {(props) => <RegisterOrderFormMobile {...props} />}
            </Formik>
        </div>
    )
}

const mapDispatchToProps = { registerOrder, showNotification }

export const RegisterOrderMobile = connect(null, mapDispatchToProps)(RegisterOrderMobileComponent)
